import _ from 'lodash'

export const objectToFolder = function(flds, path) {
  _.forEach(flds, f => {
    f.nombreOrden = f.nombre
      .toLowerCase()
      .replace('á', 'a')
      .replace('é', 'e')
      .replace('í', 'i')
      .replace('ó', 'o')
      .replace('ú', 'u')
      .replace('ñ', 'nz')
  })
  let fldsOrder = _.orderBy(flds, ['nombreOrden'], ['asc'])

  let resp = []
  _.forEach(fldsOrder, f => {
    let newPath = Array.from(path)
    newPath.push(f.nombre)

    resp.push({
      idCarpeta: f.idCarpeta,
      nombre: f.nombre,
      descripcion: f.descripcion,
      borrable: f.borrable,
      ruta: newPath,
      children: objectToFolder(
        f.subcarpetas !== undefined ? f.subcarpetas : [],
        newPath
      )
    })
  })

  return resp
}
